export const data = [
  //1
  {
    key: "c5-01",
    title: "누구 것일까?",
    grade: "1권",
    cover: require("@data/assets/blue/book1/images/cover.jpg"),
    background: require("@data/assets/blue/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book1/sounds/page23.mp3"),
      title: "Zhè shì nǐ de xiézi ma?",
      caption: [
        "zhè shì nǐ de xiézi  ma  zhè shì wǒ de xiézi",
        "zhè shì nǐ de shūbāo  ma  zhè shì wǒ de shūbāo",
        "zhè shì nǐ de màozi  ma zhè shì wǒ de màozi",
        "zhè shì nǐ de wàzi  ma zhè shì wǒ de wàzi",
        "zhè shì nǐ de xiézi  ma  zhè bú shì wǒ de xiézi",
        "zhè shì nǐ de shūbāo ma  zhè bú shì wǒ de shūbāo",
        "zhè shì nǐ de màozi  ma  zhè bú shì wǒ de màozi",
        "zhè shì nǐ de wàzi  ma  zhè bú shì wǒ de wàzi",
      ],
    },
    mov: {
      cn: "4e170d8e450295069fbe0b2d5c7bf033_01",
      en: "fd302efb51a3f1b09fd2c367b88d4791_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book1/images/img_B1-02.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_01.mp3"),
          word: "鞋子|xiézi",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-01.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_02.mp3"),
          word: "书包|shūbāo",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-04.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_03.mp3"),
          word: "帽子|màozi",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-03.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_04.mp3"),
          word: "袜子|wàzi",
        },
        //

        {
          img: require("@data/assets/blue/book1/images/img_B1-06.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_05.mp3"),
          word: "这是你的鞋子吗？|Zhè shì nǐ de xiézi ma?",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-05.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_06.mp3"),
          word: "这是你的书包吗？|Zhè shì nǐ de shūbāo ma?",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-08.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_07.mp3"),
          word: "这是你的帽子吗？|Zhè shì nǐ de màozi ma?",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-07.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_08.mp3"),
          word: "这是你的袜子吗？|Zhè shì nǐ de wàzi ma?",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-10.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_09.mp3"),
          word: "这是我的鞋子。|Zhè shì wǒ de xiézi.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-09.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_10.mp3"),
          word: "这是我的书包。|Zhè shì wǒ de shūbāo.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-12.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_11.mp3"),
          word: "这是我的帽子。|Zhè shì wǒ de màozi.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-11.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_12.mp3"),
          word: "这是我的袜子。|Zhè shì wǒ de wàzi.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-14.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_13.mp3"),
          word: "这不是我的鞋子。|Zhè bú shì wǒ de xiézi.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-13.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_14.mp3"),
          word: "这不是我的书包。|Zhè bú shì wǒ de shūbāo.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-16.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_15.mp3"),
          word: "这不是我的帽子。|Zhè bú shì wǒ de màozi.",
        },
        {
          img: require("@data/assets/blue/book1/images/img_B1-15.png"),
          sound: require("@data/assets/blue/book1/sounds/KE01_W_16.mp3"),
          word: "这不是我的袜子。|Zhè bú shì wǒ de wàzi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book1/images/img_B1-02.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_01.mp3"),
        buttons: [{ ch2: "xiézi" }, { ch: "鞋子" }, { ko: "신발" }],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-01.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_02.mp3"),
        buttons: [{ ch2: "shūbāo" }, { ch: "书包" }, { ko: "책가방" }],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-04.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_03.mp3"),
        buttons: [{ ch2: "màozi" }, { ch: "帽子" }, { ko: "모자" }],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-03.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_04.mp3"),
        buttons: [{ ch2: "wàzi" }, { ch: "袜子" }, { ko: "양말" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book1/images/img_B1-06.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_05.mp3"),
        buttons: [
          { ch2: "Zhè shì nǐ de xiézi ma?" },
          { ch: "这是你的鞋子吗？" },
          { ko: "이것은 너의 신발이야?" },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-05.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_06.mp3"),
        buttons: [
          { ch2: "Zhè shì nǐ de shūbāo ma?" },
          { ch: "这是你的书包吗？" },
          { ko: "이것은 너의 책가방이야?" },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-08.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_07.mp3"),
        buttons: [
          { ch2: "Zhè shì nǐ de màozi ma?" },
          { ch: "这是你的帽子吗？" },
          { ko: "이것은 너의 모자야?" },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-07.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_08.mp3"),
        buttons: [
          { ch2: "Zhè shì nǐ de wàzi ma?" },
          { ch: "这是你的袜子吗？" },
          { ko: "이것은 너의 양말이야?" },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-10.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_09.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ de xiézi." },
          { ch: "这是我的鞋子。" },
          { ko: "이것은 내 신발이야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-09.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_10.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ de shūbāo." },
          { ch: "这是我的书包。" },
          { ko: "이것은 내 책가방이야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-12.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_11.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ de màozi." },
          { ch: "这是我的帽子。" },
          { ko: "이것은 내 모자야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-11.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_12.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ de wàzi." },
          { ch: "这是我的袜子。" },
          { ko: "이것은 내 양말이야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-14.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_13.mp3"),
        buttons: [
          { ch2: "Zhè bú shì wǒ de xiézi." },
          { ch: "这不是我的鞋子。" },
          { ko: "이것은 내 신발이 아니야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-13.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_14.mp3"),
        buttons: [
          { ch2: "Zhè bú shì wǒ de shūbāo." },
          { ch: "这不是我的书包。" },
          { ko: "이럿은 내 책가방이 아니야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-16.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_15.mp3"),
        buttons: [
          { ch2: "Zhè bú shì wǒ de màozi." },
          { ch: "这不是我的帽子。" },
          { ko: "이것은 내 모자가 아니야." },
        ],
      },
      {
        img: require("@data/assets/blue/book1/images/img_B1-15.png"),
        sound: require("@data/assets/blue/book1/sounds/KE01_W_16.mp3"),
        buttons: [
          { ch2: "Zhè bú shì wǒ de wàzi." },
          { ch: "这不是我的袜子。" },
          { ko: "이것은 내 양말이 아니야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book1/sounds/KE01_W_03.mp3"),
          img: require("@data/assets/blue/book1/images/img_B1-04.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book1/sounds/KE01_W_12.mp3"),
          answer: [
            [require("@data/assets/blue/book1/images/img_B1-09.png"), false],
            [require("@data/assets/blue/book1/images/img_B1-11.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book1/sounds/KE01_W_02.mp3"),
          answer: [
            ["书包", true],
            ["鞋子", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book1/pages/front.jpg"),
        sound: require("@data/assets/blue/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page04.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page06.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page08.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page10.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page12.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page14.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page16.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page18.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page20.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page22.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page23.jpg"),
        sound: require("@data/assets/blue/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book1/thumbnail/front.jpg"),
      require("@data/assets/blue/book1/thumbnail/page02.jpg"),
      require("@data/assets/blue/book1/thumbnail/page03.jpg"),
      require("@data/assets/blue/book1/thumbnail/page04.jpg"),
      require("@data/assets/blue/book1/thumbnail/page05.jpg"),
      require("@data/assets/blue/book1/thumbnail/page06.jpg"),
      require("@data/assets/blue/book1/thumbnail/page07.jpg"),
      require("@data/assets/blue/book1/thumbnail/page08.jpg"),
      require("@data/assets/blue/book1/thumbnail/page09.jpg"),
      require("@data/assets/blue/book1/thumbnail/page10.jpg"),
      require("@data/assets/blue/book1/thumbnail/page11.jpg"),
      require("@data/assets/blue/book1/thumbnail/page12.jpg"),
      require("@data/assets/blue/book1/thumbnail/page13.jpg"),
      require("@data/assets/blue/book1/thumbnail/page14.jpg"),
      require("@data/assets/blue/book1/thumbnail/page15.jpg"),
      require("@data/assets/blue/book1/thumbnail/page16.jpg"),
      require("@data/assets/blue/book1/thumbnail/page17.jpg"),
      require("@data/assets/blue/book1/thumbnail/page18.jpg"),
      require("@data/assets/blue/book1/thumbnail/page19.jpg"),
      require("@data/assets/blue/book1/thumbnail/page20.jpg"),
      require("@data/assets/blue/book1/thumbnail/page21.jpg"),
      require("@data/assets/blue/book1/thumbnail/page22.jpg"),
      require("@data/assets/blue/book1/thumbnail/page23.jpg"),
      require("@data/assets/blue/book1/thumbnail/page24.jpg"),
      require("@data/assets/blue/book1/thumbnail/page25.jpg"),
      require("@data/assets/blue/book1/thumbnail/page26.jpg"),
      require("@data/assets/blue/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c5-02",
    title: "수리수리 봄 여름 가을 겨울!",
    grade: "2권",
    cover: require("@data/assets/blue/book2/images/cover.jpg"),
    background: require("@data/assets/blue/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book2/sounds/page23.mp3"),
      title: "Nǐ xǐhuan chūntiān ma?",
      caption: [
        "nǐ xǐhuan chūntiān ma",
        "wǒ xǐhuan chūntiān wǒ bù xǐhuan chūntiān",
        "nǐ xǐhuan xiàtiān ma",
        "wǒ xǐhuan xiàtiān wǒ bù xǐhuan xiàtiān",
        "nǐ xǐhuan qiūtiān ma",
        "wǒ xǐhuan qiūtiān wǒ bù xǐhuan qiūtiān",
        "nǐ xǐhuan dōngtiān ma",
        "wǒ xǐhuan dōngtiān wǒ bù xǐhuan dōngtiān",
      ],
    },
    mov: {
      cn: "2299f120ce8bef510790a923250dea24_02",
      en: "64d87f8eec1f770db16a8c90f57d1eb9_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book2/images/img_B2-02.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_01.mp3"),
          word: "春天|chūntiān",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-01.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_02.mp3"),
          word: "夏天|xiàtiān",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-04.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_03.mp3"),
          word: "秋天|qiūtiān",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-03.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_04.mp3"),
          word: "冬天|dōngtiān",
        },
        //

        {
          img: require("@data/assets/blue/book2/images/img_B2-06.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_05.mp3"),
          word: "你喜欢春天吗？|Nǐ xǐhuan chūntiān ma?",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-05.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_06.mp3"),
          word: "你喜欢夏天吗？|Nǐ xǐhuan xiàtiān ma?",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-08.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_07.mp3"),
          word: "你喜欢秋天吗？|Nǐ xǐhuan qiūtiān ma?",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-07.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_08.mp3"),
          word: "你喜欢冬天吗？|Nǐ xǐhuan dōngtiān ma?",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-10.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_09.mp3"),
          word: "我喜欢春天。|Wǒ xǐhuan chūntiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-09.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_10.mp3"),
          word: "我喜欢夏天。|Wǒ xǐhuan xiàtiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-12.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_11.mp3"),
          word: "我喜欢秋天。|Wǒ xǐhuan qiūtiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-11.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_12.mp3"),
          word: "我喜欢冬天。|Wǒ xǐhuan dōngtiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-14.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_13.mp3"),
          word: "我不喜欢春天。|Wǒ bù xǐhuan chūntiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-13.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_14.mp3"),
          word: "我不喜欢夏天。|Wǒ bù xǐhuan xiàtiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-16.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_15.mp3"),
          word: "我不喜欢秋天。|Wǒ bù xǐhuan qiūtiān.",
        },
        {
          img: require("@data/assets/blue/book2/images/img_B2-15.png"),
          sound: require("@data/assets/blue/book2/sounds/KE02_W_16.mp3"),
          word: "我不喜欢冬天。|Wǒ bù xǐhuan dōngtiān.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book2/images/img_B2-02.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_01.mp3"),
        buttons: [{ ch2: "chūntiān" }, { ch: "春天" }, { ko: "봄" }],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-01.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_02.mp3"),
        buttons: [{ ch2: "xiàtiān" }, { ch: "夏天" }, { ko: "여름" }],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-04.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_03.mp3"),
        buttons: [{ ch2: "qiūtiān" }, { ch: "秋天" }, { ko: "가을" }],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-03.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_04.mp3"),
        buttons: [{ ch2: "dōngtiān" }, { ch: "冬天" }, { ko: "겨울" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book2/images/img_B2-06.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan chūntiān ma?" },
          { ch: "你喜欢春天吗？" },
          { ko: "너는 봄을 좋아하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-05.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan xiàtiān ma?" },
          { ch: "你喜欢夏天吗？" },
          { ko: "너는 여름을 좋아하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-08.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan qiūtiān ma?" },
          { ch: "你喜欢秋天吗？" },
          { ko: "너는 가을을 좋아하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-07.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan dōngtiān ma?" },
          { ch: "你喜欢冬天吗？" },
          { ko: "너는 겨울을 좋아하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-10.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan chūntiān." },
          { ch: "我喜欢春天。" },
          { ko: "나는 봄을 좋아해." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-09.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan xiàtiān." },
          { ch: "我喜欢夏天。" },
          { ko: "나는 여름을 좋아해." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-12.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan qiūtiān." },
          { ch: "我喜欢秋天。" },
          { ko: "나는 가을을 좋아해." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-11.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan dōngtiān." },
          { ch: "我喜欢冬天。" },
          { ko: "나는 겨울을 좋아해." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-14.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bù xǐhuan chūntiān." },
          { ch: "我不喜欢春天。" },
          { ko: "나는 봄을 좋아하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-13.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bù xǐhuan xiàtiān." },
          { ch: "我不喜欢夏天。" },
          { ko: "나는 여름을 좋아하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-16.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bù xǐhuan qiūtiān." },
          { ch: "我不喜欢秋天。" },
          { ko: "나는 가을을 좋아하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book2/images/img_B2-15.png"),
        sound: require("@data/assets/blue/book2/sounds/KE02_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bù xǐhuan dōngtiān." },
          { ch: "我不喜欢冬天。" },
          { ko: "나는 겨울을 좋아하지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book2/sounds/KE02_W_02.mp3"),
          img: require("@data/assets/blue/book2/images/img_B2-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book2/sounds/KE02_W_11.mp3"),
          answer: [
            [require("@data/assets/blue/book2/images/img_B2-14.png"), false],
            [require("@data/assets/blue/book2/images/img_B2-12.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book2/sounds/KE02_W_04.mp3"),
          answer: [
            ["春天", false],
            ["冬天", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book2/pages/front.jpg"),
        sound: require("@data/assets/blue/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page04.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page06.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page08.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page10.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page12.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page14.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page16.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page18.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page20.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page22.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page23.jpg"),
        sound: require("@data/assets/blue/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book2/thumbnail/front.jpg"),
      require("@data/assets/blue/book2/thumbnail/page02.jpg"),
      require("@data/assets/blue/book2/thumbnail/page03.jpg"),
      require("@data/assets/blue/book2/thumbnail/page04.jpg"),
      require("@data/assets/blue/book2/thumbnail/page05.jpg"),
      require("@data/assets/blue/book2/thumbnail/page06.jpg"),
      require("@data/assets/blue/book2/thumbnail/page07.jpg"),
      require("@data/assets/blue/book2/thumbnail/page08.jpg"),
      require("@data/assets/blue/book2/thumbnail/page09.jpg"),
      require("@data/assets/blue/book2/thumbnail/page10.jpg"),
      require("@data/assets/blue/book2/thumbnail/page11.jpg"),
      require("@data/assets/blue/book2/thumbnail/page12.jpg"),
      require("@data/assets/blue/book2/thumbnail/page13.jpg"),
      require("@data/assets/blue/book2/thumbnail/page14.jpg"),
      require("@data/assets/blue/book2/thumbnail/page15.jpg"),
      require("@data/assets/blue/book2/thumbnail/page16.jpg"),
      require("@data/assets/blue/book2/thumbnail/page17.jpg"),
      require("@data/assets/blue/book2/thumbnail/page18.jpg"),
      require("@data/assets/blue/book2/thumbnail/page19.jpg"),
      require("@data/assets/blue/book2/thumbnail/page20.jpg"),
      require("@data/assets/blue/book2/thumbnail/page21.jpg"),
      require("@data/assets/blue/book2/thumbnail/page22.jpg"),
      require("@data/assets/blue/book2/thumbnail/page23.jpg"),
      require("@data/assets/blue/book2/thumbnail/page24.jpg"),
      require("@data/assets/blue/book2/thumbnail/page25.jpg"),
      require("@data/assets/blue/book2/thumbnail/page26.jpg"),
      require("@data/assets/blue/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c5-03",
    title: "달라도 우리는 친구",
    grade: "3권",
    cover: require("@data/assets/blue/book3/images/cover.jpg"),
    background: require("@data/assets/blue/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book3/sounds/page23.mp3"),
      title: "Nǐ yào shū ma?",
      caption: [
        "shū shū  nǐ yào shū ma",
        "wǒ yào shū wǒ bú yào shū",
        "wánjù wánjù nǐ yào wánjù ma",
        "wǒ yào wánjù wǒ bú yào wánjù",
        "yǔsǎn yǔsǎn nǐ yào yǔsǎn ma",
        "wǒ yào yǔsǎn wǒ bú yào yǔsǎn",
        "shànzi shànzi nǐ yào shànzi ma",
        "wǒ yào shànzi wǒ bú yào shànzi",
      ],
    },
    mov: {
      cn: "1ee384b69322f7074bf11d12b79e8f83_03",
      en: "febb185efd26729dba0f73cc85246149_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book3/images/img_B3-02.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_01.mp3"),
          word: "书|shū",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-01.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_02.mp3"),
          word: "玩具|wánjù",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-04.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_03.mp3"),
          word: "雨伞|yǔsǎn",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-03.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_04.mp3"),
          word: "扇子|shànzi",
        },
        //

        {
          img: require("@data/assets/blue/book3/images/img_B3-06.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_05.mp3"),
          word: "你要书吗？|Nǐ yào shū ma? ",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-05.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_06.mp3"),
          word: "你要玩具吗？|Nǐ yào wánjù ma? ",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-08.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_07.mp3"),
          word: "你要雨伞吗？|Nǐ yào yǔsǎn ma? ",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-07.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_08.mp3"),
          word: "你要扇子吗？|Nǐ yào shànzi ma? ",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-10.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_09.mp3"),
          word: "我要书。|Wǒ yào shū.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-09.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_10.mp3"),
          word: "我要玩具。|Wǒ yào wánjù.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-12.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_11.mp3"),
          word: "我要雨伞。|Wǒ yào yǔsǎn.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-11.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_12.mp3"),
          word: "我要扇子。|Wǒ yào shànzi.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-14.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_13.mp3"),
          word: "我不要书。|Wǒ bú yào shū.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-13.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_14.mp3"),
          word: "我不要玩具。|Wǒ bú yào wánjù.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-16.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_15.mp3"),
          word: "我不要雨伞。|Wǒ bú yào yǔsǎn.",
        },
        {
          img: require("@data/assets/blue/book3/images/img_B3-15.png"),
          sound: require("@data/assets/blue/book3/sounds/KE03_W_16.mp3"),
          word: "我不要扇子。|Wǒ bú yào shànzi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book3/images/img_B3-02.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_01.mp3"),
        buttons: [{ ch2: "shū" }, { ch: "书" }, { ko: "책" }],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-01.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_02.mp3"),
        buttons: [{ ch2: "wánjù" }, { ch: "玩具" }, { ko: "장난감" }],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-04.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_03.mp3"),
        buttons: [{ ch2: "yǔsǎn" }, { ch: "雨伞" }, { ko: "우산" }],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-03.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_04.mp3"),
        buttons: [{ ch2: "shànzi" }, { ch: "扇子" }, { ko: "부채" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book3/images/img_B3-06.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ yào shū ma? " },
          { ch: "你要书吗？" },
          { ko: "너는 책을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-05.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ yào wánjù ma? " },
          { ch: "你要玩具吗？" },
          { ko: "너는 장난감을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-08.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ yào yǔsǎn ma?" },
          { ch: "你要雨伞吗？" },
          { ko: "너는 우산을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-07.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ yào shànzi ma? " },
          { ch: "你要扇子吗？" },
          { ko: "너는 부채를 원하니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-10.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ yào shū." },
          { ch: "我要书。" },
          { ko: "나는 책을 원해." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-09.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ yào wánjù." },
          { ch: "我要玩具。" },
          { ko: "나는 장난감을 원해." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-12.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ yào yǔsǎn." },
          { ch: "我要雨伞。" },
          { ko: "나는 우산을 원해." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-11.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yào shànzi." },
          { ch: "我要扇子。" },
          { ko: "나는 부채를 원해." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-14.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào shū." },
          { ch: "我不要书。" },
          { ko: "나는 책을 원하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-13.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào wánjù." },
          { ch: "我不要玩具。" },
          { ko: "나는 장난감을 원하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-16.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào yǔsǎn." },
          { ch: "我不要雨伞。" },
          { ko: "나는 우산을 원하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book3/images/img_B3-15.png"),
        sound: require("@data/assets/blue/book3/sounds/KE03_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào shànzi." },
          { ch: "我不要扇子。" },
          { ko: "나는 부채를 원하지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book3/sounds/KE03_W_03.mp3"),
          img: require("@data/assets/blue/book3/images/img_B3-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book3/sounds/KE03_W_09.mp3"),
          answer: [
            [require("@data/assets/blue/book3/images/img_B3-10.png"), true],
            [require("@data/assets/blue/book3/images/img_B3-11.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book3/sounds/KE03_W_02.mp3"),
          answer: [
            ["玩具", true],
            ["扇子", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book3/pages/front.jpg"),
        sound: require("@data/assets/blue/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page04.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page06.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page08.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page10.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page12.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page14.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page16.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page18.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page20.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page22.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page23.jpg"),
        sound: require("@data/assets/blue/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book3/thumbnail/front.jpg"),
      require("@data/assets/blue/book3/thumbnail/page02.jpg"),
      require("@data/assets/blue/book3/thumbnail/page03.jpg"),
      require("@data/assets/blue/book3/thumbnail/page04.jpg"),
      require("@data/assets/blue/book3/thumbnail/page05.jpg"),
      require("@data/assets/blue/book3/thumbnail/page06.jpg"),
      require("@data/assets/blue/book3/thumbnail/page07.jpg"),
      require("@data/assets/blue/book3/thumbnail/page08.jpg"),
      require("@data/assets/blue/book3/thumbnail/page09.jpg"),
      require("@data/assets/blue/book3/thumbnail/page10.jpg"),
      require("@data/assets/blue/book3/thumbnail/page11.jpg"),
      require("@data/assets/blue/book3/thumbnail/page12.jpg"),
      require("@data/assets/blue/book3/thumbnail/page13.jpg"),
      require("@data/assets/blue/book3/thumbnail/page14.jpg"),
      require("@data/assets/blue/book3/thumbnail/page15.jpg"),
      require("@data/assets/blue/book3/thumbnail/page16.jpg"),
      require("@data/assets/blue/book3/thumbnail/page17.jpg"),
      require("@data/assets/blue/book3/thumbnail/page18.jpg"),
      require("@data/assets/blue/book3/thumbnail/page19.jpg"),
      require("@data/assets/blue/book3/thumbnail/page20.jpg"),
      require("@data/assets/blue/book3/thumbnail/page21.jpg"),
      require("@data/assets/blue/book3/thumbnail/page22.jpg"),
      require("@data/assets/blue/book3/thumbnail/page23.jpg"),
      require("@data/assets/blue/book3/thumbnail/page24.jpg"),
      require("@data/assets/blue/book3/thumbnail/page25.jpg"),
      require("@data/assets/blue/book3/thumbnail/page26.jpg"),
      require("@data/assets/blue/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c5-04",
    title: "나도 동생이 생겼어요",
    grade: "4권",
    cover: require("@data/assets/blue/book4/images/cover.jpg"),
    background: require("@data/assets/blue/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book4/sounds/page23.mp3"),
      title: "Nǐ yǒu jiějie ma?",
      caption: [
        "nǐ yǒu jiějie ma wǒ yǒu jiějie",
        "nǐ yǒu gēge ma wǒ yǒu gēge",
        "nǐ yǒu mèimei ma wǒ yǒu mèimei",
        "nǐ yǒu dìdi ma wǒ yǒu dìdi",
        "nǐ yǒu jiějie ma wǒ méiyǒu jiějie",
        "nǐ yǒu gēge ma wǒ méiyǒu gēge",
        "nǐ yǒu mèimei ma wǒ méiyǒu mèimei",
        "nǐ yǒu dìdi ma wǒ méiyǒu dìdi",
      ],
    },
    mov: {
      cn: "0488ee5d44b0289cc304fc53882df98c_04",
      en: "8fb43c1688ac1a2f5b9babd7c50ada63_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book4/images/img_B4-02.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_01.mp3"),
          word: "姐姐|jiějie",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-01.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_02.mp3"),
          word: "哥哥|gēge",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-04.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_03.mp3"),
          word: "妹妹|mèimei",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-03.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_04.mp3"),
          word: "弟弟|dìdi",
        },
        //

        {
          img: require("@data/assets/blue/book4/images/img_B4-06.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_05.mp3"),
          word: "你有姐姐吗？|Nǐ yǒu jiějie ma?",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-05.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_06.mp3"),
          word: "你有哥哥吗？|Nǐ yǒu gēge ma?",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-08.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_07.mp3"),
          word: "你有妹妹吗？|Nǐ yǒu mèimei ma?",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-07.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_08.mp3"),
          word: "你有弟弟吗？|Nǐ yǒu dìdi ma?",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-10.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_09.mp3"),
          word: "我有姐姐。|Wǒ yǒu jiějie.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-09.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_10.mp3"),
          word: "我有哥哥。|Wǒ yǒu gēge.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-12.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_11.mp3"),
          word: "我有妹妹。|Wǒ yǒu mèimei.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-11.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_12.mp3"),
          word: "我有弟弟。|Wǒ yǒu dìdi.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-14.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_13.mp3"),
          word: "我没有姐姐。|Wǒ méiyǒu jiějie.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-13.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_14.mp3"),
          word: "我没有哥哥。|Wǒ méiyǒu gēge.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-16.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_15.mp3"),
          word: "我没有妹妹。|Wǒ méiyǒu mèimei.",
        },
        {
          img: require("@data/assets/blue/book4/images/img_B4-15.png"),
          sound: require("@data/assets/blue/book4/sounds/KE04_W_16.mp3"),
          word: "我没有弟弟。|Wǒ méiyǒu dìdi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book4/images/img_B4-02.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_01.mp3"),
        buttons: [{ ch2: "jiějie" }, { ch: "姐姐" }, { ko: "언니, 누나" }],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-01.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_02.mp3"),
        buttons: [{ ch2: "gēge" }, { ch: "哥哥" }, { ko: "오빠, 형" }],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-04.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_03.mp3"),
        buttons: [{ ch2: "mèimei" }, { ch: "妹妹" }, { ko: "여동생" }],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-03.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_04.mp3"),
        buttons: [{ ch2: "dìdi" }, { ch: "弟弟" }, { ko: "남동생" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book4/images/img_B4-06.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ yǒu jiějie ma?" },
          { ch: "你有姐姐吗？" },
          { ko: "너는 언니가 있니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-05.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ yǒu gēge ma?" },
          { ch: "你有哥哥吗？" },
          { ko: "너는 오빠가 있니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-08.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ yǒu mèimei ma?" },
          { ch: "你有妹妹吗？" },
          { ko: "너는 여동생이 있니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-07.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ yǒu dìdi ma?" },
          { ch: "你有弟弟吗？" },
          { ko: "너는 남동생이 있니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-10.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu jiějie." },
          { ch: "我有姐姐。" },
          { ko: "나는 언니가 있어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-09.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu gēge." },
          { ch: "我有哥哥。" },
          { ko: "나는 오빠가 있어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-12.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu mèimei." },
          { ch: "我有妹妹。" },
          { ko: "나는 여동생이 있어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-11.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu dìdi." },
          { ch: "我有弟弟。" },
          { ko: "나는 남동생이 있어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-14.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ méiyǒu jiějie." },
          { ch: "我没有姐姐。" },
          { ko: "나는 언니가 없어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-13.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ méiyǒu gēge." },
          { ch: "我没有哥哥。" },
          { ko: "나는 오빠가 없어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-16.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ méiyǒu mèimei." },
          { ch: "我没有妹妹。" },
          { ko: "나는 여동생이 없어." },
        ],
      },
      {
        img: require("@data/assets/blue/book4/images/img_B4-15.png"),
        sound: require("@data/assets/blue/book4/sounds/KE04_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ méiyǒu dìdi." },
          { ch: "我没有弟弟。" },
          { ko: "나는 남동생이 없어." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book4/sounds/KE04_W_03.mp3"),
          img: require("@data/assets/blue/book4/images/img_B4-04.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book4/sounds/KE04_W_12.mp3"),
          answer: [
            [require("@data/assets/blue/book4/images/img_B4-10.png"), false],
            [require("@data/assets/blue/book4/images/img_B4-11.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book4/sounds/KE04_W_02.mp3"),
          answer: [
            ["哥哥", true],
            ["弟弟", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book4/pages/front.jpg"),
        sound: require("@data/assets/blue/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page04.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page06.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page08.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page10.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page12.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page14.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page16.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page18.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page20.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page22.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page23.jpg"),
        sound: require("@data/assets/blue/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book4/thumbnail/front.jpg"),
      require("@data/assets/blue/book4/thumbnail/page02.jpg"),
      require("@data/assets/blue/book4/thumbnail/page03.jpg"),
      require("@data/assets/blue/book4/thumbnail/page04.jpg"),
      require("@data/assets/blue/book4/thumbnail/page05.jpg"),
      require("@data/assets/blue/book4/thumbnail/page06.jpg"),
      require("@data/assets/blue/book4/thumbnail/page07.jpg"),
      require("@data/assets/blue/book4/thumbnail/page08.jpg"),
      require("@data/assets/blue/book4/thumbnail/page09.jpg"),
      require("@data/assets/blue/book4/thumbnail/page10.jpg"),
      require("@data/assets/blue/book4/thumbnail/page11.jpg"),
      require("@data/assets/blue/book4/thumbnail/page12.jpg"),
      require("@data/assets/blue/book4/thumbnail/page13.jpg"),
      require("@data/assets/blue/book4/thumbnail/page14.jpg"),
      require("@data/assets/blue/book4/thumbnail/page15.jpg"),
      require("@data/assets/blue/book4/thumbnail/page16.jpg"),
      require("@data/assets/blue/book4/thumbnail/page17.jpg"),
      require("@data/assets/blue/book4/thumbnail/page18.jpg"),
      require("@data/assets/blue/book4/thumbnail/page19.jpg"),
      require("@data/assets/blue/book4/thumbnail/page20.jpg"),
      require("@data/assets/blue/book4/thumbnail/page21.jpg"),
      require("@data/assets/blue/book4/thumbnail/page22.jpg"),
      require("@data/assets/blue/book4/thumbnail/page23.jpg"),
      require("@data/assets/blue/book4/thumbnail/page24.jpg"),
      require("@data/assets/blue/book4/thumbnail/page25.jpg"),
      require("@data/assets/blue/book4/thumbnail/page26.jpg"),
      require("@data/assets/blue/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c5-05",
    title: "새 친구는 어떻게 생겼을까?",
    grade: "5권",
    cover: require("@data/assets/blue/book5/images/cover.jpg"),
    background: require("@data/assets/blue/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book5/sounds/page23.mp3"),
      title: "Tā pàng ma?",
      caption: [
        "pàng pàng shòu shòu pàng shòu pàng shòu",
        "tā pàng ma tā pàng ma tā hěn pàng tā bú pàng",
        "tā shòu ma tā shòu ma tā hěn shòu tā bú shòu",
        "gāo gāo ǎi ǎi gāo ǎi gāo ǎi",
        "tā gāo ma tā gāo ma tā hěn gāo tā bù gāo",
        "tā ǎi ma tā ǎi ma tā hěn ǎi tā bù ǎi",
      ],
    },
    mov: {
      cn: "b3710467b383ee1eb58a697301a1a952_05",
      en: "1077f33db9c80a53a2c9998fd396cfc5_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book5/images/img_B5-01.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_01.mp3"),
          word: "胖|pàng",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-02.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_02.mp3"),
          word: "瘦|shòu",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-04.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_03.mp3"),
          word: "高|gāo",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-03.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_04.mp3"),
          word: "矮|ǎi",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-06.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_05.mp3"),
          word: "他胖吗？|Tā pàng ma?",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-05.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_06.mp3"),
          word: "他瘦吗？|Tā shòu ma?",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-08.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_07.mp3"),
          word: "他高吗？|Tā gāo ma?",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-07.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_08.mp3"),
          word: "他矮吗？|Tā ǎi ma?",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-10.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_09.mp3"),
          word: "他很胖。|Tā hěn pàng.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-09.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_10.mp3"),
          word: "他很瘦。|Tā hěn shòu.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-12.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_11.mp3"),
          word: "他很高。|Tā hěn gāo.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-11.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_12.mp3"),
          word: "他很矮。|Tā hěn ǎi.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-15.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_13.mp3"),
          word: "他不胖。|Tā bú pàng.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-13.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_14.mp3"),
          word: "他不瘦。|Tā bú shòu.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-16.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_15.mp3"),
          word: "他不高。|Tā bù gāo.",
        },
        {
          img: require("@data/assets/blue/book5/images/img_B5-14.png"),
          sound: require("@data/assets/blue/book5/sounds/KE05_W_16.mp3"),
          word: "他不矮。|Tā bù ǎi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book5/images/img_B5-01.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_01.mp3"),
        buttons: [{ ch2: "pàng" }, { ch: "胖" }, { ko: "뚱뚱하다" }],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-02.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_02.mp3"),
        buttons: [{ ch2: "shòu" }, { ch: "瘦" }, { ko: "날씬하다" }],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-04.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_03.mp3"),
        buttons: [{ ch2: "gāo" }, { ch: "高" }, { ko: "(키가) 크다" }],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-03.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_04.mp3"),
        buttons: [{ ch2: "ǎi" }, { ch: "矮" }, { ko: "(키가) 작다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book5/images/img_B5-06.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_05.mp3"),
        buttons: [
          { ch2: "Tā pàng ma?" },
          { ch: "他胖吗？" },
          { ko: "그는 뚱뚱해?" },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-05.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_06.mp3"),
        buttons: [
          { ch2: "Tā shòu ma?" },
          { ch: "他瘦吗？" },
          { ko: "그는 날씬해?" },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-08.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_07.mp3"),
        buttons: [
          { ch2: "Tā gāo ma?" },
          { ch: "他高吗？" },
          { ko: "그는 키가 커?" },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-07.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_08.mp3"),
        buttons: [
          { ch2: "Tā ǎi ma?" },
          { ch: "他矮吗？" },
          { ko: "그는 키가 작아?" },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-10.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_09.mp3"),
        buttons: [
          { ch2: "Tā hěn pàng." },
          { ch: "他很胖。" },
          { ko: "그는 뚱뚱해." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-09.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_10.mp3"),
        buttons: [
          { ch2: "Tā hěn shòu." },
          { ch: "他很瘦。" },
          { ko: "그는 날씬해." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-12.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_11.mp3"),
        buttons: [
          { ch2: "Tā hěn gāo." },
          { ch: "他很高。" },
          { ko: "그는 키가 커." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-11.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_12.mp3"),
        buttons: [
          { ch2: "Tā hěn ǎi." },
          { ch: "他很矮。" },
          { ko: "그는 키가 작아." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-15.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_13.mp3"),
        buttons: [
          { ch2: "Tā bú pàng." },
          { ch: "他不胖。" },
          { ko: "그는 뚱뚱하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-13.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_14.mp3"),
        buttons: [
          { ch2: "Tā bú shòu." },
          { ch: "他不瘦。" },
          { ko: "그는 날씬하지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-16.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_15.mp3"),
        buttons: [
          { ch2: "Tā bù gāo." },
          { ch: "他不高。" },
          { ko: "그는 키가 크지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book5/images/img_B5-14.png"),
        sound: require("@data/assets/blue/book5/sounds/KE05_W_16.mp3"),
        buttons: [
          { ch2: "Tā bù ǎi." },
          { ch: "他不矮。" },
          { ko: "그는 키가 작지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book5/sounds/KE05_W_03.mp3"),
          img: require("@data/assets/blue/book5/images/img_B5-04.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book5/sounds/KE05_W_09.mp3"),
          answer: [
            [require("@data/assets/blue/book5/images/img_B5-06.png"), true],
            [require("@data/assets/blue/book5/images/img_B5-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book5/sounds/KE05_W_04.mp3"),
          answer: [
            ["矮", true],
            ["胖", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book5/pages/front.jpg"),
        sound: require("@data/assets/blue/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page04.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page06.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page08.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page10.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page12.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page14.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page16.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page18.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page20.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page22.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page23.jpg"),
        sound: require("@data/assets/blue/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book5/thumbnail/front.jpg"),
      require("@data/assets/blue/book5/thumbnail/page02.jpg"),
      require("@data/assets/blue/book5/thumbnail/page03.jpg"),
      require("@data/assets/blue/book5/thumbnail/page04.jpg"),
      require("@data/assets/blue/book5/thumbnail/page05.jpg"),
      require("@data/assets/blue/book5/thumbnail/page06.jpg"),
      require("@data/assets/blue/book5/thumbnail/page07.jpg"),
      require("@data/assets/blue/book5/thumbnail/page08.jpg"),
      require("@data/assets/blue/book5/thumbnail/page09.jpg"),
      require("@data/assets/blue/book5/thumbnail/page10.jpg"),
      require("@data/assets/blue/book5/thumbnail/page11.jpg"),
      require("@data/assets/blue/book5/thumbnail/page12.jpg"),
      require("@data/assets/blue/book5/thumbnail/page13.jpg"),
      require("@data/assets/blue/book5/thumbnail/page14.jpg"),
      require("@data/assets/blue/book5/thumbnail/page15.jpg"),
      require("@data/assets/blue/book5/thumbnail/page16.jpg"),
      require("@data/assets/blue/book5/thumbnail/page17.jpg"),
      require("@data/assets/blue/book5/thumbnail/page18.jpg"),
      require("@data/assets/blue/book5/thumbnail/page19.jpg"),
      require("@data/assets/blue/book5/thumbnail/page20.jpg"),
      require("@data/assets/blue/book5/thumbnail/page21.jpg"),
      require("@data/assets/blue/book5/thumbnail/page22.jpg"),
      require("@data/assets/blue/book5/thumbnail/page23.jpg"),
      require("@data/assets/blue/book5/thumbnail/page24.jpg"),
      require("@data/assets/blue/book5/thumbnail/page25.jpg"),
      require("@data/assets/blue/book5/thumbnail/page26.jpg"),
      require("@data/assets/blue/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c5-06",
    title: "밍밍이를 찾아라!",
    grade: "6권",
    cover: require("@data/assets/blue/book6/images/cover.jpg"),
    background: require("@data/assets/blue/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book6/sounds/page23.mp3"),
      title: "Tā de yǎnjing dà ma?",
      caption: [
        "tā de yǎnjing dà ma tā de yǎnjing hěn dà",
        "tā de zuǐ xiǎo ma tā de zuǐ hěn xiǎo",
        "tā de wěiba cháng ma tā de wěiba hěn cháng",
        "tā de tuǐ duǎn ma tā de tuǐ hěn duǎn",
        "tā de yǎnjing dà ma tā de yǎnjing bú dà",
        "tā de zuǐ xiǎo ma tā de zuǐ bù xiǎo",
        "tā de wěiba cháng ma tā de wěiba bù cháng",
        "tā de tuǐ duǎn ma tā de tuǐ bù duǎn",
      ],
    },
    mov: {
      cn: "319a290ef3abf8b28a421d2209acb004_06",
      en: "6cb76d459966875c9fca000d1c29a021_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book6/images/img_B6-02.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_01.mp3"),
          word: "大 |dà",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-01.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_02.mp3"),
          word: "小|xiǎo",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-04.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_03.mp3"),
          word: "长|cháng",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-03.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_04.mp3"),
          word: "短|duǎn",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-06.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_05.mp3"),
          word: "他的嘴小吗?|Tā de zuǐ xiǎo ma?",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-05.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_06.mp3"),
          word: "他的眼睛大吗?|Tā de yǎnjing dà ma?",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-08.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_07.mp3"),
          word: "他的尾巴长吗?|Tā de wěiba cháng ma?",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-07.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_08.mp3"),
          word: "他的腿短吗?|Tā de tuǐ duǎn ma?",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-10.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_09.mp3"),
          word: "他的眼睛很大。|Tā de yǎnjing hěn dà.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-09.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_10.mp3"),
          word: "他的嘴很小。|Tā de zuǐ hěn xiǎo.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-12.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_11.mp3"),
          word: "他的尾巴很长。|Tā de wěiba hěn cháng.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-11.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_12.mp3"),
          word: "他的腿很短。|Tā de tuǐ hěn duǎn.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-14.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_13.mp3"),
          word: "他的眼睛不大。|Tā de yǎnjing bú dà.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-13.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_14.mp3"),
          word: "他的嘴不小。|Tā de zuǐ bù xiǎo.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-16.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_15.mp3"),
          word: "他的尾巴不长。|Tā de wěiba bù cháng.",
        },
        {
          img: require("@data/assets/blue/book6/images/img_B6-15.png"),
          sound: require("@data/assets/blue/book6/sounds/KE06_W_16.mp3"),
          word: "他的腿不短。|Tā de tuǐ bù duǎn.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book6/images/img_B6-02.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_01.mp3"),
        buttons: [{ ch2: "dà" }, { ch: "大" }, { ko: "크다" }],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-01.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_02.mp3"),
        buttons: [{ ch2: "xiǎo" }, { ch: "小" }, { ko: "작다" }],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-04.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_03.mp3"),
        buttons: [{ ch2: "cháng" }, { ch: "长" }, { ko: "길다" }],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-03.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_04.mp3"),
        buttons: [{ ch2: "duǎn" }, { ch: "短" }, { ko: "짧다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book6/images/img_B6-06.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_05.mp3"),
        buttons: [
          { ch2: "Tā de zuǐ xiǎo ma?" },
          { ch: "他的嘴小吗?" },
          { ko: "그의 입은 작아?" },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-05.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_06.mp3"),
        buttons: [
          { ch2: "Tā de yǎnjing dà ma?" },
          { ch: "他的眼睛大吗?" },
          { ko: "그의 눈은 커?" },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-08.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_07.mp3"),
        buttons: [
          { ch2: "Tā de wěiba cháng ma?" },
          { ch: "他的尾巴长吗?" },
          { ko: "그의 꼬리는 길어?" },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-07.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_08.mp3"),
        buttons: [
          { ch2: "Tā de tuǐ duǎn ma?" },
          { ch: "他的腿短吗?" },
          { ko: "그의 다리는 짧아?" },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-10.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_09.mp3"),
        buttons: [
          { ch2: "Tā de yǎnjing hěn dà." },
          { ch: "他的眼睛很大。" },
          { ko: "그의 눈은 매우 크다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-09.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_10.mp3"),
        buttons: [
          { ch2: "Tā de zuǐ hěn xiǎo." },
          { ch: "他的嘴很小。" },
          { ko: "그의 입이 작다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-12.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_11.mp3"),
        buttons: [
          { ch2: "Tā de wěiba hěn cháng." },
          { ch: "他的尾巴很长。" },
          { ko: "그의 꼬리는 매우 길다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-11.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_12.mp3"),
        buttons: [
          { ch2: "Tā de tuǐ hěn duǎn." },
          { ch: "他的腿很短。" },
          { ko: "그의 다리는 매우 짧다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-14.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_13.mp3"),
        buttons: [
          { ch2: "Tā de yǎnjing bú dà." },
          { ch: "他的眼睛不大。" },
          { ko: "그의 눈은 크지 않다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-13.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_14.mp3"),
        buttons: [
          { ch2: "Tā de zuǐ bù xiǎo." },
          { ch: "他的嘴不小。" },
          { ko: "그의 입은 작지 않다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-16.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_15.mp3"),
        buttons: [
          { ch2: "Tā de wěiba bù cháng." },
          { ch: "他的尾巴不长。" },
          { ko: "그는 꼬리가 길지 않다." },
        ],
      },
      {
        img: require("@data/assets/blue/book6/images/img_B6-15.png"),
        sound: require("@data/assets/blue/book6/sounds/KE06_W_16.mp3"),
        buttons: [
          { ch2: "Tā de tuǐ bù duǎn." },
          { ch: "他的腿不短。" },
          { ko: "그의 다리는 짧지 않다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book6/sounds/KE06_W_04.mp3"),
          img: require("@data/assets/blue/book6/images/img_B6-04.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book6/sounds/KE06_W_10.mp3"),
          answer: [
            [require("@data/assets/blue/book6/images/img_B6-09.png"), true],
            [require("@data/assets/blue/book6/images/img_B6-11.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book6/sounds/KE06_W_01.mp3"),
          answer: [
            ["大 ", true],
            ["小", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book6/pages/front.jpg"),
        sound: require("@data/assets/blue/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page04.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page06.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page08.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page10.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page12.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page14.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page16.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page18.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page20.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page22.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page23.jpg"),
        sound: require("@data/assets/blue/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book6/thumbnail/front.jpg"),
      require("@data/assets/blue/book6/thumbnail/page02.jpg"),
      require("@data/assets/blue/book6/thumbnail/page03.jpg"),
      require("@data/assets/blue/book6/thumbnail/page04.jpg"),
      require("@data/assets/blue/book6/thumbnail/page05.jpg"),
      require("@data/assets/blue/book6/thumbnail/page06.jpg"),
      require("@data/assets/blue/book6/thumbnail/page07.jpg"),
      require("@data/assets/blue/book6/thumbnail/page08.jpg"),
      require("@data/assets/blue/book6/thumbnail/page09.jpg"),
      require("@data/assets/blue/book6/thumbnail/page10.jpg"),
      require("@data/assets/blue/book6/thumbnail/page11.jpg"),
      require("@data/assets/blue/book6/thumbnail/page12.jpg"),
      require("@data/assets/blue/book6/thumbnail/page13.jpg"),
      require("@data/assets/blue/book6/thumbnail/page14.jpg"),
      require("@data/assets/blue/book6/thumbnail/page15.jpg"),
      require("@data/assets/blue/book6/thumbnail/page16.jpg"),
      require("@data/assets/blue/book6/thumbnail/page17.jpg"),
      require("@data/assets/blue/book6/thumbnail/page18.jpg"),
      require("@data/assets/blue/book6/thumbnail/page19.jpg"),
      require("@data/assets/blue/book6/thumbnail/page20.jpg"),
      require("@data/assets/blue/book6/thumbnail/page21.jpg"),
      require("@data/assets/blue/book6/thumbnail/page22.jpg"),
      require("@data/assets/blue/book6/thumbnail/page23.jpg"),
      require("@data/assets/blue/book6/thumbnail/page24.jpg"),
      require("@data/assets/blue/book6/thumbnail/page25.jpg"),
      require("@data/assets/blue/book6/thumbnail/page26.jpg"),
      require("@data/assets/blue/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c5-07",
    title: "아빠와 요리해요",
    grade: "7권",
    cover: require("@data/assets/blue/book7/images/cover.jpg"),
    background: require("@data/assets/blue/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book7/sounds/page23.mp3"),
      title: "Zhège tián bu tián?",
      caption: [
        "zhège tián bu tián tián bu tián",
        "zhège hěn tián zhège bù tián",
        "zhège là bu là là bu là",
        "zhège hěn là zhège bú là",
        "zhège suān bu suān suān bu suān",
        "zhège hěn suān zhège bù suān",
        "zhège xián bu xián xián bu xián",
        "zhège hěn xián zhège bù xián",
      ],
    },
    mov: {
      cn: "d7bc185224f75312d6e15d46a7da987d_07",
      en: "b6bc57f6e1eaba22b748856a4578901d_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book7/images/img_B7-02.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_01.mp3"),
          word: "辣|là",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-01.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_02.mp3"),
          word: "甜|tián",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-04.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_03.mp3"),
          word: "酸|suān",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-03.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_04.mp3"),
          word: "咸|xián",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-06.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_05.mp3"),
          word: "这个甜不甜？|Zhège tián bu tián?",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-05.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_06.mp3"),
          word: "这个辣不辣？|Zhège là bu là?",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-08.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_07.mp3"),
          word: "这个酸不酸？|Zhège suān bu suān?",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-07.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_08.mp3"),
          word: "这个咸不咸？|Zhège xián bu xián?",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-06.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_09.mp3"),
          word: "这个很甜。|Zhège hěn tián.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-09.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_10.mp3"),
          word: "这个很辣。|Zhège hěn là.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-12.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_11.mp3"),
          word: "这个很酸。|Zhège hěn suān. ",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-11.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_12.mp3"),
          word: "这个很咸。|Zhège hěn xián.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-14.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_13.mp3"),
          word: "这个不甜。|Zhège bù tián.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-13.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_14.mp3"),
          word: "这个不辣。|Zhège bú là.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-16.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_15.mp3"),
          word: "这个不酸。|Zhège bù suān.",
        },
        {
          img: require("@data/assets/blue/book7/images/img_B7-15.png"),
          sound: require("@data/assets/blue/book7/sounds/KE07_W_16.mp3"),
          word: "这个不咸。|Zhège bù xián.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book7/images/img_B7-02.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_01.mp3"),
        buttons: [{ ch2: "là" }, { ch: "辣" }, { ko: "맵다" }],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-01.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_02.mp3"),
        buttons: [{ ch2: "tián" }, { ch: "甜" }, { ko: "달다" }],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-04.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_03.mp3"),
        buttons: [{ ch2: "suān" }, { ch: "酸" }, { ko: "시다" }],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-03.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_04.mp3"),
        buttons: [{ ch2: "xián" }, { ch: "咸" }, { ko: "짜다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book7/images/img_B7-06.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_05.mp3"),
        buttons: [
          { ch2: "Zhège tián bu tián?" },
          { ch: "这个甜不甜？" },
          { ko: "이것은 달아요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-05.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_06.mp3"),
        buttons: [
          { ch2: "Zhège là bu là?" },
          { ch: "这个辣不辣？" },
          { ko: "이것은 매워요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-08.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_07.mp3"),
        buttons: [
          { ch2: "Zhège suān bu suān?" },
          { ch: "这个酸不酸？" },
          { ko: "이것은 셔요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-07.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_08.mp3"),
        buttons: [
          { ch2: "Zhège xián bu xián?" },
          { ch: "这个咸不咸？" },
          { ko: "이것은 짜요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-06.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_09.mp3"),
        buttons: [
          { ch2: "Zhège hěn tián." },
          { ch: "这个很甜。" },
          { ko: "이것은 달아요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-09.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_10.mp3"),
        buttons: [
          { ch2: "Zhège hěn là." },
          { ch: "这个很辣。" },
          { ko: "이것은 매워요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-12.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_11.mp3"),
        buttons: [
          { ch2: "Zhège hěn suān. " },
          { ch: "这个很酸。" },
          { ko: "이것은 셔요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-11.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_12.mp3"),
        buttons: [
          { ch2: "Zhège hěn xián." },
          { ch: "这个很咸。" },
          { ko: "이것은 짜요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-14.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_13.mp3"),
        buttons: [
          { ch2: "Zhège bù tián." },
          { ch: "这个不甜。" },
          { ko: "이것은 달지 않아요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-13.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_14.mp3"),
        buttons: [
          { ch2: "Zhège bú là." },
          { ch: "这个不辣。" },
          { ko: "이것은 맵지 않아요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-16.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_15.mp3"),
        buttons: [
          { ch2: "Zhège bù suān." },
          { ch: "这个不酸。" },
          { ko: "이것은 시지 않아요." },
        ],
      },
      {
        img: require("@data/assets/blue/book7/images/img_B7-15.png"),
        sound: require("@data/assets/blue/book7/sounds/KE07_W_16.mp3"),
        buttons: [
          { ch2: "Zhège bù xián." },
          { ch: "这个不咸。" },
          { ko: "이것은 짜지 않아요." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book7/sounds/KE07_W_02.mp3"),
          img: require("@data/assets/blue/book7/images/img_B7-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book7/sounds/KE07_W_14.mp3"),
          answer: [
            [require("@data/assets/blue/book7/images/img_B7-14.png"), false],
            [require("@data/assets/blue/book7/images/img_B7-13.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book7/sounds/KE07_W_11.mp3"),
          answer: [
            ["这个很酸。", true],
            ["这个很咸。", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book7/pages/front.jpg"),
        sound: require("@data/assets/blue/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page04.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page06.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page08.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page10.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page12.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page14.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page16.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page18.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page20.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page22.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page23.jpg"),
        sound: require("@data/assets/blue/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book7/thumbnail/front.jpg"),
      require("@data/assets/blue/book7/thumbnail/page02.jpg"),
      require("@data/assets/blue/book7/thumbnail/page03.jpg"),
      require("@data/assets/blue/book7/thumbnail/page04.jpg"),
      require("@data/assets/blue/book7/thumbnail/page05.jpg"),
      require("@data/assets/blue/book7/thumbnail/page06.jpg"),
      require("@data/assets/blue/book7/thumbnail/page07.jpg"),
      require("@data/assets/blue/book7/thumbnail/page08.jpg"),
      require("@data/assets/blue/book7/thumbnail/page09.jpg"),
      require("@data/assets/blue/book7/thumbnail/page10.jpg"),
      require("@data/assets/blue/book7/thumbnail/page11.jpg"),
      require("@data/assets/blue/book7/thumbnail/page12.jpg"),
      require("@data/assets/blue/book7/thumbnail/page13.jpg"),
      require("@data/assets/blue/book7/thumbnail/page14.jpg"),
      require("@data/assets/blue/book7/thumbnail/page15.jpg"),
      require("@data/assets/blue/book7/thumbnail/page16.jpg"),
      require("@data/assets/blue/book7/thumbnail/page17.jpg"),
      require("@data/assets/blue/book7/thumbnail/page18.jpg"),
      require("@data/assets/blue/book7/thumbnail/page19.jpg"),
      require("@data/assets/blue/book7/thumbnail/page20.jpg"),
      require("@data/assets/blue/book7/thumbnail/page21.jpg"),
      require("@data/assets/blue/book7/thumbnail/page22.jpg"),
      require("@data/assets/blue/book7/thumbnail/page23.jpg"),
      require("@data/assets/blue/book7/thumbnail/page24.jpg"),
      require("@data/assets/blue/book7/thumbnail/page25.jpg"),
      require("@data/assets/blue/book7/thumbnail/page26.jpg"),
      require("@data/assets/blue/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c5-08",
    title: "나무 한 그루",
    grade: "8권",
    cover: require("@data/assets/blue/book8/images/cover.jpg"),
    background: require("@data/assets/blue/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book8/sounds/page23.mp3"),
      title: "Nǐ lěng bu lěng?",
      caption: [
        "lěng lěng lěng nǐ lěng bu lěng wǒ hěn lěng",
        "rè rè rè nǐ rè bu rè wǒ hěn rè",
        "kě kě kě nǐ kě bu kě wǒ hěn kě",
        "è è è nǐ è bu è wǒ hěn è",
        "lěng lěng lěng nǐ lěng bu lěng wǒ bù lěng",
        "rè rè rè nǐ rè bu rè wǒ bú rè",
        "kě kě kě nǐ kě bu kě  wǒ bù kě",
        "è è è nǐ è bu è wǒ bú è",
      ],
    },
    mov: {
      cn: "98c1565563878e478cd2d51970fdfa59_08",
      en: "0b718cdc46197d179fcb69a98a1c3230_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book8/images/img_B8-02.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_01.mp3"),
          word: "冷|lěng",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-01.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_02.mp3"),
          word: "热|rè",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-04.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_03.mp3"),
          word: "渴|kě",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-03.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_04.mp3"),
          word: "饿|è",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-06.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_05.mp3"),
          word: "你冷不冷？|Nǐ lěng bu lěng?",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-05.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_06.mp3"),
          word: "你热不热？|Nǐ rè bu rè?",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-08.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_07.mp3"),
          word: "你渴不渴？|Nǐ kě bu kě?",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-07.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_08.mp3"),
          word: "你饿不饿？|Nǐ è bu è?",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-10.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_09.mp3"),
          word: "我很冷。|Wǒ hěn lěng.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-09.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_10.mp3"),
          word: "我很热。|Wǒ hěn rè.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-12.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_11.mp3"),
          word: "我很渴。|Wǒ hěn kě.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-11.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_12.mp3"),
          word: "我很饿。|Wǒ hěn è.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-14.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_13.mp3"),
          word: "我不冷。|Wǒ bù lěng.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-13.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_14.mp3"),
          word: "我不热。|Wǒ bú rè.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-16.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_15.mp3"),
          word: "我不渴。|Wǒ bù kě.",
        },
        {
          img: require("@data/assets/blue/book8/images/img_B8-15.png"),
          sound: require("@data/assets/blue/book8/sounds/KE08_W_16.mp3"),
          word: "我不饿。|Wǒ bú è.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book8/images/img_B8-02.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_01.mp3"),
        buttons: [{ ch2: "lěng" }, { ch: "冷" }, { ko: "춥다" }],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-01.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_02.mp3"),
        buttons: [{ ch2: "rè" }, { ch: "热" }, { ko: "덥다" }],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-04.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_03.mp3"),
        buttons: [{ ch2: "kě" }, { ch: "渴" }, { ko: "목마르다" }],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-03.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_04.mp3"),
        buttons: [{ ch2: "è" }, { ch: "饿" }, { ko: "배고프다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book8/images/img_B8-06.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ lěng bu lěng?" },
          { ch: "你冷不冷？" },
          { ko: "너는 춥니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-05.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ rè bu rè?" },
          { ch: "你热不热？" },
          { ko: "너는 덥니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-08.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ kě bu kě?" },
          { ch: "你渴不渴？" },
          { ko: "너는 목마르니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-07.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ è bu è?" },
          { ch: "你饿不饿？" },
          { ko: "너는 배고프니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-10.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ hěn lěng." },
          { ch: "我很冷。" },
          { ko: "나는 추워." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-09.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ hěn rè." },
          { ch: "我很热。" },
          { ko: "나는 더워." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-12.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ hěn kě." },
          { ch: "我很渴。" },
          { ko: "나는 목말라." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-11.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ hěn è." },
          { ch: "我很饿。" },
          { ko: "나는 배고파." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-14.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bù lěng." },
          { ch: "我不冷。" },
          { ko: "나는 춥지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-13.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bú rè." },
          { ch: "我不热。" },
          { ko: "나는 덥지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-16.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bù kě." },
          { ch: "我不渴。" },
          { ko: "나는 목마르지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book8/images/img_B8-15.png"),
        sound: require("@data/assets/blue/book8/sounds/KE08_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bú è." },
          { ch: "我不饿。" },
          { ko: "나는 배고프지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book8/sounds/KE08_W_02.mp3"),
          img: require("@data/assets/blue/book8/images/img_B8-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book8/sounds/KE08_W_09.mp3"),
          answer: [
            [require("@data/assets/blue/book8/images/img_B8-10.png"), true],
            [require("@data/assets/blue/book8/images/img_B8-12.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book8/sounds/KE08_W_16.mp3"),
          answer: [
            ["我不冷。", false],
            ["我不饿。", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book8/pages/front.jpg"),
        sound: require("@data/assets/blue/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page04.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page06.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page08.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page10.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page12.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page14.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page16.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page18.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page20.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page22.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page23.jpg"),
        sound: require("@data/assets/blue/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book8/thumbnail/front.jpg"),
      require("@data/assets/blue/book8/thumbnail/page02.jpg"),
      require("@data/assets/blue/book8/thumbnail/page03.jpg"),
      require("@data/assets/blue/book8/thumbnail/page04.jpg"),
      require("@data/assets/blue/book8/thumbnail/page05.jpg"),
      require("@data/assets/blue/book8/thumbnail/page06.jpg"),
      require("@data/assets/blue/book8/thumbnail/page07.jpg"),
      require("@data/assets/blue/book8/thumbnail/page08.jpg"),
      require("@data/assets/blue/book8/thumbnail/page09.jpg"),
      require("@data/assets/blue/book8/thumbnail/page10.jpg"),
      require("@data/assets/blue/book8/thumbnail/page11.jpg"),
      require("@data/assets/blue/book8/thumbnail/page12.jpg"),
      require("@data/assets/blue/book8/thumbnail/page13.jpg"),
      require("@data/assets/blue/book8/thumbnail/page14.jpg"),
      require("@data/assets/blue/book8/thumbnail/page15.jpg"),
      require("@data/assets/blue/book8/thumbnail/page16.jpg"),
      require("@data/assets/blue/book8/thumbnail/page17.jpg"),
      require("@data/assets/blue/book8/thumbnail/page18.jpg"),
      require("@data/assets/blue/book8/thumbnail/page19.jpg"),
      require("@data/assets/blue/book8/thumbnail/page20.jpg"),
      require("@data/assets/blue/book8/thumbnail/page21.jpg"),
      require("@data/assets/blue/book8/thumbnail/page22.jpg"),
      require("@data/assets/blue/book8/thumbnail/page23.jpg"),
      require("@data/assets/blue/book8/thumbnail/page24.jpg"),
      require("@data/assets/blue/book8/thumbnail/page25.jpg"),
      require("@data/assets/blue/book8/thumbnail/page26.jpg"),
      require("@data/assets/blue/book8/thumbnail/page27.jpg"),
    ],
  },

  //9
  {
    key: "c5-09",
    title: "꿈틀이는 내 친구",
    grade: "9권",
    cover: require("@data/assets/blue/book9/images/cover.jpg"),
    background: require("@data/assets/blue/book9/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book9/sounds/page23.mp3"),
      title: "Nǐ yào xǐ shǒu ma?",
      caption: [
        "nǐ yào xǐ shǒu ma yào yào wǒ yào xǐ shǒu",
        "nǐ yào xǐ shǒu ma bú yào bú yào wǒ bú yào xǐ shǒu",
        "nǐ yào chī fàn ma yào yào wǒ yào chī fàn",
        "nǐ yào chī fàn ma bú yào bú yào wǒ bú yào chī fàn",
        "nǐ yào hē shuǐ ma yào yào wǒ yào hē shuǐ",
        "nǐ yào hē shuǐ ma bú yào bú yào wǒ bú yào hē shuǐ",
        "nǐ yào shàng cèsuǒ ma yào yào wǒ yào shàng cèsuǒ",
        "nǐ yào shàng cèsuǒ ma bú yào bú yào wǒ bú yào shàng cèsuǒ",
      ],
    },
    mov: {
      cn: "fba1f691571139a990a6b8b189176903_09",
      en: "9f9c7c66c616b22630a1d4d4fd9b2a91_09",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book9/images/img_B9-02.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_01.mp3"),
          word: "洗手|xǐ shǒu",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-01.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_02.mp3"),
          word: "吃饭|chī fàn",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-04.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_03.mp3"),
          word: "喝水|hē shuǐ",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-03.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_04.mp3"),
          word: "上厕所|shàng cèsuǒ",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-06.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_05.mp3"),
          word: "你要洗手吗？|Nǐ yào xǐ shǒu ma?",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-05.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_06.mp3"),
          word: "你要吃饭吗？|Nǐ yào chī fàn ma?",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-08.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_07.mp3"),
          word: "你要喝水吗？|Nǐ yào hē shuǐ ma ?",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-07.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_08.mp3"),
          word: "你要上厕所吗？|Nǐ yào shàng cèsuǒ ma?",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-10.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_09.mp3"),
          word: "我要洗手。|Wǒ yào xǐ shǒu.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-09.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_10.mp3"),
          word: "我要吃饭。|Wǒ yào chī fàn.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-12.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_11.mp3"),
          word: "我要喝水。|Wǒ yào hē shuǐ.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-11.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_12.mp3"),
          word: "我要上厕所。|Wǒ yào shàng cèsuǒ.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-14.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_13.mp3"),
          word: "我不要洗手。|Wǒ bú yào xǐ shǒu.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-13.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_14.mp3"),
          word: "我不要吃饭。|Wǒ bú yào chī fàn.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-16.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_15.mp3"),
          word: "我不要喝水。|Wǒ bú yào hē shuǐ.",
        },
        {
          img: require("@data/assets/blue/book9/images/img_B9-15.png"),
          sound: require("@data/assets/blue/book9/sounds/KE09_W_16.mp3"),
          word: "我不要上厕所。|Wǒ bú yào shàng cèsuǒ.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book9/images/img_B9-02.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_01.mp3"),
        buttons: [{ ch2: "xǐ shǒu" }, { ch: "洗手" }, { ko: "손을 씻다" }],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-01.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_02.mp3"),
        buttons: [{ ch2: "chī fàn" }, { ch: "吃饭" }, { ko: "밥을 먹다" }],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-04.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_03.mp3"),
        buttons: [{ ch2: "hē shuǐ" }, { ch: "喝水" }, { ko: "물을 마시다" }],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-03.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_04.mp3"),
        buttons: [
          { ch2: "shàng cèsuǒ" },
          { ch: "上厕所" },
          { ko: "화장실에 가다" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book9/images/img_B9-06.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ yào xǐ shǒu ma?" },
          { ch: "你要洗手吗？" },
          { ko: "너는 손을 씻을 거니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-05.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ yào chī fàn ma?" },
          { ch: "你要吃饭吗？" },
          { ko: "너는 밥을 먹을 거니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-08.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ yào hē shuǐ ma ?" },
          { ch: "你要喝水吗？" },
          { ko: "너는 물을 마실 거니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-07.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ yào shàng cèsuǒ ma?" },
          { ch: "你要上厕所吗？" },
          { ko: "너는 화장실에 갈 거니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-10.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ yào xǐ shǒu." },
          { ch: "我要洗手。" },
          { ko: "나는 손을 씻을 거야." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-09.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ yào chī fàn." },
          { ch: "我要吃饭。" },
          { ko: "나는 밥을 먹을 거야." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-12.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ yào hē shuǐ." },
          { ch: "我要喝水。" },
          { ko: "나는 물을 마실 거야." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-11.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yào shàng cèsuǒ." },
          { ch: "我要上厕所。" },
          { ko: "나는 화장실에 갈 거야." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-14.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào xǐ shǒu." },
          { ch: "我不要洗手。" },
          { ko: "나는 손을 씻고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-13.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào chī fàn." },
          { ch: "我不要吃饭。" },
          { ko: "나는 밥을 먹고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-16.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào hē shuǐ." },
          { ch: "我不要喝水。" },
          { ko: "나는 물을 마시고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book9/images/img_B9-15.png"),
        sound: require("@data/assets/blue/book9/sounds/KE09_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bú yào shàng cèsuǒ." },
          { ch: "我不要上厕所。" },
          { ko: "나는 화장실에 가고 싶지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book9/sounds/KE09_W_03.mp3"),
          img: require("@data/assets/blue/book9/images/img_B9-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book9/sounds/KE09_W_12.mp3"),
          answer: [
            [require("@data/assets/blue/book9/images/img_B9-07.png"), true],
            [require("@data/assets/blue/book9/images/img_B9-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book9/sounds/KE09_W_02.mp3"),
          answer: [
            ["吃饭", true],
            ["上厕所", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book9/pages/front.jpg"),
        sound: require("@data/assets/blue/book9/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book9/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page04.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page06.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page08.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page10.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page12.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page14.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page16.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page18.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page20.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page22.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page23.jpg"),
        sound: require("@data/assets/blue/book9/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book9/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book9/thumbnail/front.jpg"),
      require("@data/assets/blue/book9/thumbnail/page02.jpg"),
      require("@data/assets/blue/book9/thumbnail/page03.jpg"),
      require("@data/assets/blue/book9/thumbnail/page04.jpg"),
      require("@data/assets/blue/book9/thumbnail/page05.jpg"),
      require("@data/assets/blue/book9/thumbnail/page06.jpg"),
      require("@data/assets/blue/book9/thumbnail/page07.jpg"),
      require("@data/assets/blue/book9/thumbnail/page08.jpg"),
      require("@data/assets/blue/book9/thumbnail/page09.jpg"),
      require("@data/assets/blue/book9/thumbnail/page10.jpg"),
      require("@data/assets/blue/book9/thumbnail/page11.jpg"),
      require("@data/assets/blue/book9/thumbnail/page12.jpg"),
      require("@data/assets/blue/book9/thumbnail/page13.jpg"),
      require("@data/assets/blue/book9/thumbnail/page14.jpg"),
      require("@data/assets/blue/book9/thumbnail/page15.jpg"),
      require("@data/assets/blue/book9/thumbnail/page16.jpg"),
      require("@data/assets/blue/book9/thumbnail/page17.jpg"),
      require("@data/assets/blue/book9/thumbnail/page18.jpg"),
      require("@data/assets/blue/book9/thumbnail/page19.jpg"),
      require("@data/assets/blue/book9/thumbnail/page20.jpg"),
      require("@data/assets/blue/book9/thumbnail/page21.jpg"),
      require("@data/assets/blue/book9/thumbnail/page22.jpg"),
      require("@data/assets/blue/book9/thumbnail/page23.jpg"),
      require("@data/assets/blue/book9/thumbnail/page24.jpg"),
      require("@data/assets/blue/book9/thumbnail/page25.jpg"),
      require("@data/assets/blue/book9/thumbnail/page26.jpg"),
      require("@data/assets/blue/book9/thumbnail/page27.jpg"),
    ],
  },
  //10
  {
    key: "c5-10",
    title: "잘 못해도 괜찮아",
    grade: "10권",
    cover: require("@data/assets/blue/book10/images/cover.jpg"),
    background: require("@data/assets/blue/book10/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book10/sounds/page23.mp3"),
      title: "Nǐ huì shuō Hànyǔ ma?",
      caption: [
        "nǐ hǎo zàijiàn shuō Hànyǔ shuō Hànyǔ",
        "nǐ huì shuō Hànyǔ ma wǒ huì shuō Hànyǔ",
        "nǐ huì shuō Hànyǔ ma wǒ bú huì shuō Hànyǔ",
        "tán gāngqín tán gāngqín",
        "nǐ huì tán gāngqín ma wǒ huì tán gāngqín",
        "nǐ huì tán gāngqín ma wǒ bú huì tán gāngqín",
        "yóuyǒng yóuyǒng nǐ huì yóuyǒng ma wǒ huì yóuyǒng",
        "nǐ huì yóuyǒng ma wǒ bú huì yóuyǒng",
        "qí zìxíngchē qí zìxíngchē",
        "nǐ huì qí zìxíngchē ma wǒ huì qí zìxíngchē",
        "nǐ huì qí zìxíngchē ma wǒ bú huì qí zìxíngchē",
      ],
    },
    mov: {
      cn: "14795a49002aff9ab0e34b703e257e04_10",
      en: "70c32abbd185ba3cbada517f0a3aefde_10",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book10/images/img_B10-02.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_01.mp3"),
          word: "说汉语|shuō Hànyǔ",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-01.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_02.mp3"),
          word: "弹钢琴|tán gāngqín",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-04.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_03.mp3"),
          word: "游泳|yóuyǒng",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-03.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_04.mp3"),
          word: "骑自行车|qí zìxíngchē",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-06.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_05.mp3"),
          word: "你会说汉语吗？|Nǐ huì shuō Hànyǔ ma?",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-05.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_06.mp3"),
          word: "你会弹钢琴吗？|Nǐ huì tán gāngqín ma?",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-08.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_07.mp3"),
          word: "你会游泳吗？|Nǐ huì yóuyǒng ma?",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-07.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_08.mp3"),
          word: "你会骑自行车吗？|Nǐ huì qí zìxíngchē ma?",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-10.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_09.mp3"),
          word: "我会说汉语。|Wǒ huì shuō Hànyǔ.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-09.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_10.mp3"),
          word: "我会弹钢琴。|Wǒ huì tán gāngqín.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-12.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_11.mp3"),
          word: "我会游泳。|Wǒ huì yóuyǒng.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-11.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_12.mp3"),
          word: "我会骑自行车。|Wǒ huì qí zìxíngchē.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-14.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_13.mp3"),
          word: "我不会说汉语。|Wǒ bú huì shuō Hànyǔ.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-13.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_14.mp3"),
          word: "我不会弹钢琴。|Wǒ bú huì tán gāngqín.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-16.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_15.mp3"),
          word: "我不会游泳。|Wǒ bú huì yóuyǒng.",
        },
        {
          img: require("@data/assets/blue/book10/images/img_B10-15.png"),
          sound: require("@data/assets/blue/book10/sounds/KE10_W_16.mp3"),
          word: "我不会骑自行车。|Wǒ bú huì qí zìxíngchē.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book10/images/img_B10-02.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_01.mp3"),
        buttons: [
          { ch2: "shuō Hànyǔ" },
          { ch: "说汉语" },
          { ko: "중국어를 말하다" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-01.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_02.mp3"),
        buttons: [
          { ch2: "tán gāngqín" },
          { ch: "弹钢琴" },
          { ko: "피아노를 연주하다" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-04.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_03.mp3"),
        buttons: [{ ch2: "yóuyǒng" }, { ch: "游泳" }, { ko: "수영을 하다" }],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-03.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_04.mp3"),
        buttons: [
          { ch2: "qí zìxíngchē" },
          { ch: "骑自行车" },
          { ko: "자전거를 타다" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book10/images/img_B10-06.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ huì shuō Hànyǔ ma?" },
          { ch: "你会说汉语吗？" },
          { ko: "너는 중국어를 말할 줄 아니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-05.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ huì tán gāngqín ma?" },
          { ch: "你会弹钢琴吗？" },
          { ko: "너는 피아노를 연주할 줄 아니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-08.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ huì yóuyǒng ma?" },
          { ch: "你会游泳吗？" },
          { ko: "너는 수영을 할 줄 아니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-07.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ huì qí zìxíngchē ma?" },
          { ch: "你会骑自行车吗？" },
          { ko: "너는 자전거를 탈 줄 아니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-10.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ huì shuō Hànyǔ." },
          { ch: "我会说汉语。" },
          { ko: "나는 중국어를 말할 줄 알아." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-09.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ huì tán gāngqín." },
          { ch: "我会弹钢琴。" },
          { ko: "나는 피아노를 연주할 줄 알아." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-12.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ huì yóuyǒng." },
          { ch: "我会游泳。" },
          { ko: "나는 수영을 할 줄 알아. " },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-11.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ huì qí zìxíngchē." },
          { ch: "我会骑自行车。" },
          { ko: "나는 자전거를 탈 줄 알아." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-14.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bú huì shuō Hànyǔ." },
          { ch: "我不会说汉语。" },
          { ko: "나는 중국어를 말할 줄 몰라." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-13.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bú huì tán gāngqín." },
          { ch: "我不会弹钢琴。" },
          { ko: "나는 피아노를 연주할 줄 몰라." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-16.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bú huì yóuyǒng." },
          { ch: "我不会游泳。" },
          { ko: "나는 수영을 할 줄 몰라." },
        ],
      },
      {
        img: require("@data/assets/blue/book10/images/img_B10-15.png"),
        sound: require("@data/assets/blue/book10/sounds/KE10_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bú huì qí zìxíngchē." },
          { ch: "我不会骑自行车。" },
          { ko: "나는 자전거를 탈 줄 몰라." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book10/sounds/KE10_W_04.mp3"),
          img: require("@data/assets/blue/book10/images/img_B10-03.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book10/sounds/KE10_W_11.mp3"),
          answer: [
            [require("@data/assets/blue/book10/images/img_B10-13.png"), false],
            [require("@data/assets/blue/book10/images/img_B10-08.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book10/sounds/KE10_W_01.mp3"),
          answer: [
            ["说汉语", true],
            ["弹钢琴", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book10/pages/front.jpg"),
        sound: require("@data/assets/blue/book10/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book10/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page04.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page06.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page08.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page10.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page12.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page14.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page16.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page18.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page20.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page22.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page23.jpg"),
        sound: require("@data/assets/blue/book10/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book10/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book10/thumbnail/front.jpg"),
      require("@data/assets/blue/book10/thumbnail/page02.jpg"),
      require("@data/assets/blue/book10/thumbnail/page03.jpg"),
      require("@data/assets/blue/book10/thumbnail/page04.jpg"),
      require("@data/assets/blue/book10/thumbnail/page05.jpg"),
      require("@data/assets/blue/book10/thumbnail/page06.jpg"),
      require("@data/assets/blue/book10/thumbnail/page07.jpg"),
      require("@data/assets/blue/book10/thumbnail/page08.jpg"),
      require("@data/assets/blue/book10/thumbnail/page09.jpg"),
      require("@data/assets/blue/book10/thumbnail/page10.jpg"),
      require("@data/assets/blue/book10/thumbnail/page11.jpg"),
      require("@data/assets/blue/book10/thumbnail/page12.jpg"),
      require("@data/assets/blue/book10/thumbnail/page13.jpg"),
      require("@data/assets/blue/book10/thumbnail/page14.jpg"),
      require("@data/assets/blue/book10/thumbnail/page15.jpg"),
      require("@data/assets/blue/book10/thumbnail/page16.jpg"),
      require("@data/assets/blue/book10/thumbnail/page17.jpg"),
      require("@data/assets/blue/book10/thumbnail/page18.jpg"),
      require("@data/assets/blue/book10/thumbnail/page19.jpg"),
      require("@data/assets/blue/book10/thumbnail/page20.jpg"),
      require("@data/assets/blue/book10/thumbnail/page21.jpg"),
      require("@data/assets/blue/book10/thumbnail/page22.jpg"),
      require("@data/assets/blue/book10/thumbnail/page23.jpg"),
      require("@data/assets/blue/book10/thumbnail/page24.jpg"),
      require("@data/assets/blue/book10/thumbnail/page25.jpg"),
      require("@data/assets/blue/book10/thumbnail/page26.jpg"),
      require("@data/assets/blue/book10/thumbnail/page27.jpg"),
    ],
  },
  //11
  {
    key: "c5-11",
    title: "끈기가 중요해!",
    grade: "11권",
    cover: require("@data/assets/blue/book11/images/cover.jpg"),
    background: require("@data/assets/blue/book11/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book11/sounds/page23.mp3"),
      title: "Nǐ xiǎng huàhuàr ma?",
      caption: [
        "nǐ xiǎng huàhuàr ma nǐ xiǎng huàhuàr ma",
        "wǒ xiǎng huàhuàr wǒ bù xiǎng huàhuàr",
        "nǐ xiǎng chànggēr ma nǐ xiǎng chànggēr ma",
        "wǒ xiǎng chànggēr wǒ bù xiǎng chànggēr",
        "nǐ xiǎng tī zúqiú ma nǐ xiǎng tī zúqiú ma",
        "wǒ xiǎng tī zúqiú wǒ bù xiǎng tī zúqiú",
        "nǐ xiǎng zuò cài ma nǐ xiǎng zuò cài ma",
        "wǒ xiǎng zuò cài wǒ bù xiǎng zuò cài",
      ],
    },
    mov: {
      cn: "37ca0e2b37bffbb698d20d93bad2f19d_11",
      en: "f4c6ba518b56760ffcdd6e904f4ec16e_11",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book11/images/img_B11-02.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_01.mp3"),
          word: "画画儿|huàhuàr",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-01.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_02.mp3"),
          word: "唱歌儿|chànggēr",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-04.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_03.mp3"),
          word: "踢足球|tī zúqiú",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-03.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_04.mp3"),
          word: "做菜|zuò cài",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-06.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_05.mp3"),
          word: "你想画画儿吗？|Nǐ xiǎng huàhuàr ma?",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-05.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_06.mp3"),
          word: "你想唱歌儿吗？|Nǐ xiǎng chànggēr ma?",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-08.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_07.mp3"),
          word: "你想踢足球吗?|Nǐ xiǎng tī zúqiú ma?",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-07.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_08.mp3"),
          word: "你想做菜吗？|Nǐ xiǎng zuò cài ma?",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-10.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_09.mp3"),
          word: "我想画画儿。|Wǒ xiǎng huàhuàr.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-09.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_10.mp3"),
          word: "我想唱歌儿。|Wǒ xiǎng chànggēr.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-12.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_11.mp3"),
          word: "我想踢足球。|Wǒ xiǎng tī zúqiú.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-11.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_12.mp3"),
          word: "我想做菜。|Wǒ xiǎng zuò cài.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-14.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_13.mp3"),
          word: "我不想画画儿。|Wǒ bù xiǎng huàhuàr.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-13.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_14.mp3"),
          word: "我不想唱歌儿。|Wǒ bù xiǎng chànggēr.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-16.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_15.mp3"),
          word: "我不想踢足球。|Wǒ bù xiǎng tī zúqiú.",
        },
        {
          img: require("@data/assets/blue/book11/images/img_B11-15.png"),
          sound: require("@data/assets/blue/book11/sounds/KE11_W_16.mp3"),
          word: "我不想做菜。|Wǒ bù xiǎng zuò cài.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book11/images/img_B11-02.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_01.mp3"),
        buttons: [
          { ch2: "huàhuàr" },
          { ch: "画画儿" },
          { ko: "그림을 그리다" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-01.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_02.mp3"),
        buttons: [
          { ch2: "chànggēr" },
          { ch: "唱歌儿" },
          { ko: "노래를 부르다" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-04.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_03.mp3"),
        buttons: [{ ch2: "tī zúqiú" }, { ch: "踢足球" }, { ko: "축구를 하다" }],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-03.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_04.mp3"),
        buttons: [{ ch2: "zuò cài" }, { ch: "做菜" }, { ko: "요리를 하다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book11/images/img_B11-06.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ xiǎng huàhuàr ma?" },
          { ch: "你想画画儿吗？" },
          { ko: "너는 그림을 그리고 싶니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-05.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ xiǎng chànggēr ma?" },
          { ch: "你想唱歌儿吗？" },
          { ko: "너는 노래를 부르고 싶니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-08.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ xiǎng tī zúqiú ma?" },
          { ch: "你想踢足球吗?" },
          { ko: "너는 축구를 하고 싶니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-07.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ xiǎng zuò cài ma?" },
          { ch: "你想做菜吗？" },
          { ko: "너는 요리를 하고 싶니?" },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-10.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng huàhuàr." },
          { ch: "我想画画儿。" },
          { ko: "나는 그림을 그리고 싶어." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-09.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng chànggēr." },
          { ch: "我想唱歌儿。" },
          { ko: "나는 노래를 부르고 싶어." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-12.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng tī zúqiú." },
          { ch: "我想踢足球。" },
          { ko: "나는 축구를 하고 싶어." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-11.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng zuò cài." },
          { ch: "我想做菜。" },
          { ko: "나는 요리를 하고 싶어." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-14.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ bù xiǎng huàhuàr." },
          { ch: "我不想画画儿。" },
          { ko: "나는 그림을 그리고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-13.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bù xiǎng chànggēr." },
          { ch: "我不想唱歌儿。" },
          { ko: "나는 노래를 부르고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-16.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bù xiǎng tī zúqiú." },
          { ch: "我不想踢足球。" },
          { ko: "나는 축구를 하고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/blue/book11/images/img_B11-15.png"),
        sound: require("@data/assets/blue/book11/sounds/KE11_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bù xiǎng zuò cài." },
          { ch: "我不想做菜。" },
          { ko: "나는 요리를 하고 싶지 않아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book11/sounds/KE11_W_01.mp3"),
          img: require("@data/assets/blue/book11/images/img_B11-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book11/sounds/KE11_W_12.mp3"),
          answer: [
            [require("@data/assets/blue/book11/images/img_B11-11.png"), true],
            [require("@data/assets/blue/book11/images/img_B11-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book11/sounds/KE11_W_03.mp3"),
          answer: [
            ["踢足球", true],
            ["唱歌儿", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book11/pages/front.jpg"),
        sound: require("@data/assets/blue/book11/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book11/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page04.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page06.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page08.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page10.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page12.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page14.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page16.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page18.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page20.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page22.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page23.jpg"),
        sound: require("@data/assets/blue/book11/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book11/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book11/thumbnail/front.jpg"),
      require("@data/assets/blue/book11/thumbnail/page02.jpg"),
      require("@data/assets/blue/book11/thumbnail/page03.jpg"),
      require("@data/assets/blue/book11/thumbnail/page04.jpg"),
      require("@data/assets/blue/book11/thumbnail/page05.jpg"),
      require("@data/assets/blue/book11/thumbnail/page06.jpg"),
      require("@data/assets/blue/book11/thumbnail/page07.jpg"),
      require("@data/assets/blue/book11/thumbnail/page08.jpg"),
      require("@data/assets/blue/book11/thumbnail/page09.jpg"),
      require("@data/assets/blue/book11/thumbnail/page10.jpg"),
      require("@data/assets/blue/book11/thumbnail/page11.jpg"),
      require("@data/assets/blue/book11/thumbnail/page12.jpg"),
      require("@data/assets/blue/book11/thumbnail/page13.jpg"),
      require("@data/assets/blue/book11/thumbnail/page14.jpg"),
      require("@data/assets/blue/book11/thumbnail/page15.jpg"),
      require("@data/assets/blue/book11/thumbnail/page16.jpg"),
      require("@data/assets/blue/book11/thumbnail/page17.jpg"),
      require("@data/assets/blue/book11/thumbnail/page18.jpg"),
      require("@data/assets/blue/book11/thumbnail/page19.jpg"),
      require("@data/assets/blue/book11/thumbnail/page20.jpg"),
      require("@data/assets/blue/book11/thumbnail/page21.jpg"),
      require("@data/assets/blue/book11/thumbnail/page22.jpg"),
      require("@data/assets/blue/book11/thumbnail/page23.jpg"),
      require("@data/assets/blue/book11/thumbnail/page24.jpg"),
      require("@data/assets/blue/book11/thumbnail/page25.jpg"),
      require("@data/assets/blue/book11/thumbnail/page26.jpg"),
      require("@data/assets/blue/book11/thumbnail/page27.jpg"),
    ],
  },
  //12
  {
    key: "c5-12",
    title: "내 맘대로 할 거야",
    grade: "12권",
    cover: require("@data/assets/blue/book12/images/cover.jpg"),
    background: require("@data/assets/blue/book12/pages/page05.jpg"),
    song: {
      url: require("@data/assets/blue/book12/sounds/page23.mp3"),
      title: "Wǒ kěyǐ wánr yóuxì ma?",
      caption: [
        "wánr yóuxì wánr yóuxì wǒ kěyǐ wánr yóuxì ma",
        "nǐ kěyǐ wánr yóuxì nǐ bù kěyǐ wánr yóuxì",
        "kàn diànshì kàn diànshì wǒ kěyǐ kàn diànshì ma",
        "nǐ kěyǐ kàn diànshì nǐ bù kěyǐ kàn diànshì",
        "chī táng chī táng wǒ kěyǐ chī táng ma",
        "nǐ kěyǐ chī táng nǐ bù kěyǐ chī táng",
        "hē kělè hē kělè wǒ kěyǐ hē kělè ma",
        "nǐ kěyǐ hē kělè  nǐ bù kěyǐ hē kělè",
      ],
    },
    mov: {
      cn: "f915f910032b8259511dba113b6fe8ba_12",
      en: "e74b0185f670f83c3e77d1d17f78fb76_12",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/blue/book12/images/img_B12-02.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_01.mp3"),
          word: "玩儿游戏|wánr yóuxì",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-01.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_02.mp3"),
          word: "看电视|kàn diànshì",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-04.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_03.mp3"),
          word: "吃糖|chī táng",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-03.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_04.mp3"),
          word: "喝可乐|hē kělè",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-06.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_05.mp3"),
          word: "我可以玩儿游戏吗？|Wǒ kěyǐ wánr yóuxì ma?",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-05.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_06.mp3"),
          word: "我可以看电视吗？|Wǒ kěyǐ kàn diànshì ma?",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-08.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_07.mp3"),
          word: "我可以吃糖吗？|Wǒ kěyǐ chī táng ma?",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-07.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_08.mp3"),
          word: "我可以喝可乐吗？|Wǒ kěyǐ hē kělè ma?",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-10.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_09.mp3"),
          word: "你可以玩儿游戏。|Nǐ kěyǐ wánr yóuxì.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-09.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_10.mp3"),
          word: "你可以看电视。|Nǐ kěyǐ kàn diànshì.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-12.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_11.mp3"),
          word: "你可以吃糖。|Nǐ kěyǐ chī táng.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-11.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_12.mp3"),
          word: "你可以喝可乐。|Nǐ kěyǐ hē kělè.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-14.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_13.mp3"),
          word: "你不可以玩儿游戏。|Nǐ bù kěyǐ wánr yóuxì.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-13.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_14.mp3"),
          word: "你不可以看电视。|Nǐ bù kěyǐ kàn diànshì.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-16.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_15.mp3"),
          word: "你不可以吃糖。|Nǐ bù kěyǐ chī táng.",
        },
        {
          img: require("@data/assets/blue/book12/images/img_B12-15.png"),
          sound: require("@data/assets/blue/book12/sounds/KE12_W_16.mp3"),
          word: "你不可以喝可乐。|Nǐ bù kěyǐ hē kělè.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/blue/book12/images/img_B12-02.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_01.mp3"),
        buttons: [
          { ch2: "wánr yóuxì" },
          { ch: "玩儿游戏" },
          { ko: "게임을 하다" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-01.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_02.mp3"),
        buttons: [
          { ch2: "kàn diànshì" },
          { ch: "看电视" },
          { ko: "텔레비전을 보다" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-04.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_03.mp3"),
        buttons: [{ ch2: "chī táng" }, { ch: "吃糖" }, { ko: "사탕을 먹다" }],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-03.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_04.mp3"),
        buttons: [
          { ch2: "hē kělè" },
          { ch: "喝可乐" },
          { ko: "콜라를 마시다" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/blue/book12/images/img_B12-06.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_05.mp3"),
        buttons: [
          { ch2: "Wǒ kěyǐ wánr yóuxì ma?" },
          { ch: "我可以玩儿游戏吗？" },
          { ko: "게임을 해도 될까요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-05.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ kěyǐ kàn diànshì ma?" },
          { ch: "我可以看电视吗？" },
          { ko: "텔레비전을 봐도 될까요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-08.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ kěyǐ chī táng ma?" },
          { ch: "我可以吃糖吗？" },
          { ko: "사탕을 먹어도 될까요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-07.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ kěyǐ hē kělè ma?" },
          { ch: "我可以喝可乐吗？" },
          { ko: "콜라를 마셔도 될까요?" },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-10.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_09.mp3"),
        buttons: [
          { ch2: "Nǐ kěyǐ wánr yóuxì." },
          { ch: "你可以玩儿游戏。" },
          { ko: "게임을 해도 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-09.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_10.mp3"),
        buttons: [
          { ch2: "Nǐ kěyǐ kàn diànshì." },
          { ch: "你可以看电视。" },
          { ko: "텔레비전을 봐도 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-12.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ kěyǐ chī táng." },
          { ch: "你可以吃糖。" },
          { ko: "사탕을 먹어도 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-11.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_12.mp3"),
        buttons: [
          { ch2: "Nǐ kěyǐ hē kělè." },
          { ch: "你可以喝可乐。" },
          { ko: "콜라를 마셔도 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-14.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_13.mp3"),
        buttons: [
          { ch2: "Nǐ bù kěyǐ wánr yóuxì." },
          { ch: "你不可以玩儿游戏。" },
          { ko: "게임을 하면 안 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-13.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_14.mp3"),
        buttons: [
          { ch2: "Nǐ bù kěyǐ kàn diànshì." },
          { ch: "你不可以看电视。" },
          { ko: "텔레비전을 보면 안 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-16.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_15.mp3"),
        buttons: [
          { ch2: "Nǐ bù kěyǐ chī táng." },
          { ch: "你不可以吃糖。" },
          { ko: "사탕을 먹으면 안 돼." },
        ],
      },
      {
        img: require("@data/assets/blue/book12/images/img_B12-15.png"),
        sound: require("@data/assets/blue/book12/sounds/KE12_W_16.mp3"),
        buttons: [
          { ch2: "Nǐ bù kěyǐ hē kělè." },
          { ch: "你不可以喝可乐。" },
          { ko: "콜라를 마시면 안 돼." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/blue/book12/sounds/KE12_W_01.mp3"),
          img: require("@data/assets/blue/book12/images/img_B12-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/blue/book12/sounds/KE12_W_03.mp3"),
          answer: [
            [require("@data/assets/blue/book12/images/img_B12-04.png"), true],
            [require("@data/assets/blue/book12/images/img_B12-03.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/blue/book12/sounds/KE12_W_04.mp3"),
          answer: [
            ["喝可乐", true],
            ["看电视", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/blue/book12/pages/front.jpg"),
        sound: require("@data/assets/blue/book12/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/blue/book12/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page04.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page06.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page08.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page10.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page12.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page14.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page16.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page18.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page20.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page22.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page23.jpg"),
        sound: require("@data/assets/blue/book12/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/blue/book12/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/blue/book12/thumbnail/front.jpg"),
      require("@data/assets/blue/book12/thumbnail/page02.jpg"),
      require("@data/assets/blue/book12/thumbnail/page03.jpg"),
      require("@data/assets/blue/book12/thumbnail/page04.jpg"),
      require("@data/assets/blue/book12/thumbnail/page05.jpg"),
      require("@data/assets/blue/book12/thumbnail/page06.jpg"),
      require("@data/assets/blue/book12/thumbnail/page07.jpg"),
      require("@data/assets/blue/book12/thumbnail/page08.jpg"),
      require("@data/assets/blue/book12/thumbnail/page09.jpg"),
      require("@data/assets/blue/book12/thumbnail/page10.jpg"),
      require("@data/assets/blue/book12/thumbnail/page11.jpg"),
      require("@data/assets/blue/book12/thumbnail/page12.jpg"),
      require("@data/assets/blue/book12/thumbnail/page13.jpg"),
      require("@data/assets/blue/book12/thumbnail/page14.jpg"),
      require("@data/assets/blue/book12/thumbnail/page15.jpg"),
      require("@data/assets/blue/book12/thumbnail/page16.jpg"),
      require("@data/assets/blue/book12/thumbnail/page17.jpg"),
      require("@data/assets/blue/book12/thumbnail/page18.jpg"),
      require("@data/assets/blue/book12/thumbnail/page19.jpg"),
      require("@data/assets/blue/book12/thumbnail/page20.jpg"),
      require("@data/assets/blue/book12/thumbnail/page21.jpg"),
      require("@data/assets/blue/book12/thumbnail/page22.jpg"),
      require("@data/assets/blue/book12/thumbnail/page23.jpg"),
      require("@data/assets/blue/book12/thumbnail/page24.jpg"),
      require("@data/assets/blue/book12/thumbnail/page25.jpg"),
      require("@data/assets/blue/book12/thumbnail/page26.jpg"),
      require("@data/assets/blue/book12/thumbnail/page27.jpg"),
    ],
  },
];
